export default {"src":"https://fishbrain.com/_next/static/media/rainbowTrout.e4b8adaa.svg","height":115,"width":230,"blurWidth":0,"blurHeight":0};